export var AppendToBodyPositionTypeEnum;
(function (AppendToBodyPositionTypeEnum) {
    AppendToBodyPositionTypeEnum["BOTTOM_LEFT"] = "BottomLeft";
    AppendToBodyPositionTypeEnum["TOP_RIGHT"] = "TopRight";
    // Above the parent, aligned to its left edge: a menu that opens upward
    AppendToBodyPositionTypeEnum["TOP_LEFT"] = "TopLeft";
})(AppendToBodyPositionTypeEnum || (AppendToBodyPositionTypeEnum = {}));
